import styles from './Footer.module.css';
// eslint-disable-next-line
import logo from '!file-loader!./logo-vit.svg';

interface FooterProps {
  rendered: boolean;
}

const Footer = (props: FooterProps) => {
  if (!props.rendered) {
    return null;
  }

  return (
    <div className={styles.footer}>
      <div className={styles.contentWrapper}>
        <img style={{ height: '50px' }} src={logo} alt="Metria logo" />
        <div className={styles.infoContainer}>
          <div className={styles.info}>
            <div>
              <strong>Metria AB</strong>
            </div>
            <div>801 83 Gävle, Sverige</div>
          </div>
          <div className={styles.info}>
            <div>
              <strong>E-post</strong>
            </div>
            <div>info@metria.se</div>
          </div>
          <div className={styles.info}>
            <div>
              <strong>Telefon</strong>
            </div>
            <div>010 - 121 80 00</div>
          </div>
        </div>
        <div className={styles.copyright}>Copyright © Metria AB 2021</div>
      </div>
    </div>
  );
};

export default Footer;
